<template>
  <div class="d-flex flex-column min-vh-100">

    <!-- ── Header ── -->
    <header v-if="!isAdminRoute" class="bg-primary text-white shadow-sm sticky-top">
      <div class="container py-2 py-md-3">
        <div class="d-flex align-items-center justify-content-between">

          <!-- Logo -->
          <router-link to="/" class="d-flex align-items-center text-white text-decoration-none">
            <img src="@/assets/logo.png" alt="Logo" height="42" class="me-2" />
            <span class="fw-bold fs-6 fs-md-5 logo-text">Achiziții Profesionale</span>
          </router-link>

          <!-- Desktop nav -->
          <nav class="nav d-none d-lg-flex align-items-center">
            <router-link to="/" class="nav-link text-white px-2">
              <i class="fas fa-home me-1"></i> Acasă
            </router-link>
            <router-link to="/stiri" class="nav-link text-white px-2">
              <i class="fas fa-bullhorn me-1"></i> Anunțuri
            </router-link>

            <!-- Dropdown consultanță -->
            <div
              class="nav-item position-relative"
              @mouseover="showConsultanta = true"
              @mouseleave="showConsultanta = false"
            >
              <a class="nav-link text-white dropdown-toggle px-2" href="#" role="button">
                <i class="fas fa-file-alt me-1"></i> Consultanță
              </a>
              <transition name="drop-fade">
                <div
                  v-if="showConsultanta"
                  class="position-absolute bg-white text-dark shadow rounded-3 py-2"
                  style="top: calc(100% + 4px); left: 0; min-width: 300px; z-index: 9999;"
                >
                  <router-link class="dropdown-item px-3 py-2" to="/consultanta/noile-praguri">Noile praguri pentru achiziții publice</router-link>
                  <router-link class="dropdown-item px-3 py-2" to="/consultanta/dosarul-achizitiei">Dosarul achiziției publice, ce conține?</router-link>
                  <router-link class="dropdown-item px-3 py-2" to="/consultanta/contestatii">Depunerea unei contestații</router-link>
                  <router-link class="dropdown-item px-3 py-2" to="/consultanta/garantie-participare">Garanția de participare</router-link>
                  <router-link class="dropdown-item px-3 py-2" to="/consultanta/oug45">Modificarea legii prin OUG 45/2018</router-link>
                  <router-link class="dropdown-item px-3 py-2" to="/consultanta/seap-vs-sicap">SEAP vs SICAP</router-link>
                  <router-link class="dropdown-item px-3 py-2" to="/consultanta/atestat-expert">Atestat expert achiziții</router-link>
                  <router-link class="dropdown-item px-3 py-2" to="/consultanta/legislatie">Legislație achiziții publice</router-link>
                </div>
              </transition>
            </div>

            <template v-if="clientLoggedIn">
              <router-link to="/client/dashboard" class="nav-link text-white px-2">
                <i class="fas fa-user me-1"></i> Dashboard
              </router-link>
              <button class="btn btn-outline-light btn-sm ms-2" @click="logoutClient">
                <i class="fas fa-sign-out-alt me-1"></i> Logout
              </button>
            </template>
            <template v-else>
              <router-link to="/client/login" class="nav-link text-white px-2">
                <i class="fas fa-user me-1"></i> Login
              </router-link>
            </template>

            <router-link to="/contact" class="btn btn-light text-primary fw-semibold ms-3 btn-sm px-3">
              <i class="fas fa-calendar-alt me-1"></i> Programează
            </router-link>
          </nav>

          <!-- Hamburger (mobil) -->
          <button
            class="btn btn-sm text-white d-lg-none border-0 p-1"
            @click="toggleMobileMenu"
            aria-label="Meniu"
          >
            <i :class="['fas', showMobileMenu ? 'fa-times' : 'fa-bars', 'fa-lg']"></i>
          </button>
        </div>

        <!-- Meniu mobil -->
        <transition name="slide-fade">
          <div v-show="showMobileMenu" class="mt-2 pt-2 border-top border-white border-opacity-25 d-lg-none">

            <router-link to="/" class="mobile-nav-link">
              <i class="fas fa-home me-2"></i> Acasă
            </router-link>
            <router-link to="/stiri" class="mobile-nav-link">
              <i class="fas fa-bullhorn me-2"></i> Anunțuri
            </router-link>

            <!-- Acordeon consultanță mobil -->
            <div
              class="mobile-nav-link d-flex justify-content-between"
              @click="showMobileConsultanta = !showMobileConsultanta"
              style="cursor: pointer;"
            >
              <span><i class="fas fa-file-alt me-2"></i> Informații</span>
              <i :class="['fas', showMobileConsultanta ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
            </div>
            <transition name="slide-fade">
              <div v-show="showMobileConsultanta" class="ps-3 pb-1">
                <router-link to="/consultanta/noile-praguri" class="mobile-sub-link">Noile praguri</router-link>
                <router-link to="/consultanta/dosarul-achizitiei" class="mobile-sub-link">Dosarul achiziției</router-link>
                <router-link to="/consultanta/contestatii" class="mobile-sub-link">Contestații</router-link>
                <router-link to="/consultanta/garantie-participare" class="mobile-sub-link">Garanția de participare</router-link>
                <router-link to="/consultanta/oug45" class="mobile-sub-link">Modificare OUG 45</router-link>
                <router-link to="/consultanta/seap-vs-sicap" class="mobile-sub-link">SEAP vs SICAP</router-link>
                <router-link to="/consultanta/atestat-expert" class="mobile-sub-link">Atestat expert</router-link>
                <router-link to="/consultanta/legislatie" class="mobile-sub-link">Legislație</router-link>
              </div>
            </transition>

            <template v-if="clientLoggedIn">
              <router-link to="/client/dashboard" class="mobile-nav-link">
                <i class="fas fa-user me-2"></i> Dashboard
              </router-link>
              <button @click="logoutClient" class="btn btn-sm btn-outline-light w-100 mt-2 mb-1">
                <i class="fas fa-sign-out-alt me-1"></i> Logout
              </button>
            </template>
            <template v-else>
              <router-link to="/client/login" class="mobile-nav-link">
                <i class="fas fa-user me-2"></i> Login
              </router-link>
            </template>

            <router-link to="/contact" class="btn btn-light text-primary fw-semibold w-100 mt-2 mb-1">
              <i class="fas fa-calendar-alt me-1"></i> Programează consultanță
            </router-link>
          </div>
        </transition>
      </div>
    </header>

    <!-- ── Content ── -->
    <main class="flex-grow-1">
      <router-view />
    </main>

    <!-- ── Footer ── -->
    <footer v-if="!isAdminRoute" class="bg-light text-dark pt-4 border-top mt-auto">
      <div class="container">
        <div class="row g-3">
          <div class="col-12 col-md-4 text-center d-flex align-items-center justify-content-center">
            <img src="@/assets/logo.png" alt="Logo" height="180" class="img-fluid" style="max-height: 180px;" />
          </div>
          <div class="col-6 col-md-4">
            <h6 class="fw-bold mb-2">Linkuri utile</h6>
            <ul class="list-unstyled small">
              <li class="mb-1"><router-link to="/" class="text-dark text-decoration-none">Acasă</router-link></li>
              <li class="mb-1"><router-link to="/contact" class="text-dark text-decoration-none">Programează consultanță</router-link></li>
              <li class="mb-1"><router-link to="/stiri" class="text-dark text-decoration-none">Anunțuri</router-link></li>
              <li class="mb-1"><router-link to="/termeni" class="text-dark text-decoration-none">Termeni și condiții</router-link></li>
              <li><router-link to="/confidentialitate" class="text-dark text-decoration-none">Politica de confidențialitate</router-link></li>
            </ul>
          </div>
          <div class="col-6 col-md-4">
            <h6 class="fw-bold mb-2">Contact</h6>
            <ul class="list-unstyled small">
              <li class="mb-1"><i class="fas fa-phone me-2 text-primary"></i><a href="tel:+40766718238" class="text-dark text-decoration-none">+40 766 718 238</a></li>
              <li class="mb-1"><i class="fas fa-envelope me-2 text-primary"></i><a href="mailto:contact@consultantaachizitii.ro" class="text-dark text-decoration-none footer-email">contact@consultantaachizitii.ro</a></li>
              <li class="mb-1"><i class="fas fa-map-marker-alt me-2 text-primary"></i> Calea Apeductului 13, București</li>
              <li class="mb-1"><i class="fas fa-file-alt me-2 text-primary"></i> CUI: 39403793</li>
              <li><i class="fas fa-briefcase me-2 text-primary"></i> J40/7350/2024</li>
            </ul>
          </div>
        </div>

        <div class="text-center text-muted py-2 border-top mt-3 small">
          <a href="/admin/login" target="_blank" class="text-decoration-none text-muted fw-semibold">Panou de administrare</a><br />
          &copy; {{ new Date().getFullYear() }} SC ACHIZITII PROFESIONALE SRL. Toate drepturile rezervate.<br />
          Site realizat de <a href="https://www.rusin.ro" target="_blank" class="text-decoration-none text-muted fw-semibold">Luca Rusin</a>
        </div>
      </div>
    </footer>

    <!-- ── Cookie Consent ── -->
    <transition name="fade">
      <div
        v-if="showCookieConsent"
        class="position-fixed bottom-0 start-0 end-0 bg-dark text-white py-2 px-3 d-flex flex-column flex-md-row justify-content-between align-items-center small shadow"
        style="z-index: 9999;"
      >
        <span class="text-center text-md-start mb-2 mb-md-0">
          Folosim cookie-uri pentru a vă oferi cea mai bună experiență.
          <router-link to="/confidentialitate" class="text-white text-decoration-underline">Detalii</router-link>
        </span>
        <div class="d-flex gap-2">
          <button class="btn btn-sm btn-outline-light" @click="declineCookies">Refuz</button>
          <button class="btn btn-sm btn-light text-dark fw-semibold" @click="acceptCookies">Accept</button>
        </div>
      </div>
    </transition>

    <!-- ── WhatsApp ── -->
<a
  href="https://wa.me/40766718238"
  target="_blank"
  rel="noopener noreferrer"
  class="btn btn-success position-fixed d-flex align-items-center justify-content-center rounded-circle shadow"
  style="bottom: 190px; right: 16px; width: 50px; height: 50px; z-index: 9998; background-color: #25D366; border: none;"
  aria-label="Contactează-ne pe WhatsApp"
>
  <i class="fab fa-whatsapp fs-4 text-white"></i>
</a>

    <!-- ── Back to Top ── -->
    <transition name="fade">
      <button
        v-show="showBackToTop"
        class="btn btn-secondary position-fixed btn-back-top"
        style="bottom: 130px; right: 16px; z-index: 9998;"
        @click="scrollToTop"
        aria-label="Sus"
      >
        <i class="fas fa-chevron-up"></i>
      </button>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showMobileMenu: false,
      showConsultanta: false,
      showMobileConsultanta: false,
      showCookieConsent: !localStorage.getItem('cookiesAccepted'),
      showBackToTop: false,
      clientLoggedIn: !!localStorage.getItem('client_id'),
      clientName: localStorage.getItem('client_name') || '',
    };
  },

  computed: {
    isAdminRoute() {
      return this.$route.path.startsWith('/admin');
    },
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('client-auth-changed', this.syncAuthState);
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('client-auth-changed', this.syncAuthState);
  },

  watch: {
    $route() {
      this.showMobileMenu = false;
      this.showMobileConsultanta = false;
      this.showConsultanta = false;
    },
  },

  methods: {
    syncAuthState() {
      this.clientLoggedIn = !!localStorage.getItem('client_id');
      this.clientName = localStorage.getItem('client_name') || '';
    },
    acceptCookies() {
      localStorage.setItem('cookiesAccepted', 'true');
      this.showCookieConsent = false;
    },
    declineCookies() {
      localStorage.setItem('cookiesAccepted', 'false');
      this.showCookieConsent = false;
    },
    logoutClient() {
      localStorage.removeItem('client_id');
      localStorage.removeItem('client_name');
      this.clientLoggedIn = false;
      this.clientName = '';
      this.$router.push('/');
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    handleScroll() {
      this.showBackToTop = window.scrollY > 300;
    },
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu;
    },
  },
};
</script>

<style scoped>
/* ── Nav ── */
.router-link-exact-active {
  font-weight: 700;
  opacity: 0.95;
}

.nav-link {
  display: flex;
  align-items: center;
  font-size: 0.9rem;
}

/* ── Mobile nav links ── */
.mobile-nav-link {
  display: flex;
  align-items: center;
  color: white;
  text-decoration: none;
  padding: 0.45rem 0.25rem;
  font-size: 0.95rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.mobile-sub-link {
  display: block;
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
  padding: 0.3rem 0;
  font-size: 0.87rem;
}

.mobile-sub-link:hover,
.mobile-nav-link:hover {
  color: white;
}

/* ── Dropdown ── */
.dropdown-item {
  color: #212529;
  font-size: 0.88rem;
}
.dropdown-item:hover {
  background-color: #f0f4ff;
  color: #0d6efd;
}

/* ── Logo text ── */
.logo-text {
  line-height: 1.2;
}

/* ── Footer email ── */
.footer-email {
  word-break: break-all;
}

/* ── WhatsApp button ── */
.btn-whatsapp {
  background-color: #25d366;
  color: white;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  font-size: 1.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  animation: pulse 2.5s infinite;
  box-shadow: 0 4px 14px rgba(37, 211, 102, 0.4);
}

/* ── Back to top ── */
.btn-back-top {
  border-radius: 50%;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

/* ── Animations ── */
@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50%       { transform: scale(1.1); }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all 0.25s ease;
}
.slide-fade-enter-from, .slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.drop-fade-enter-active, .drop-fade-leave-active {
  transition: all 0.2s ease;
}
.drop-fade-enter-from, .drop-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

/* ── Mobile ── */
@media (max-width: 576px) {
  .logo-text {
    font-size: 0.88rem;
  }
  header img {
    height: 36px !important;
  }
}
</style>